import { Provider } from '@angular/core';

import { OnBoardingVideoUseCasesImpl } from '@app/domain/use-cases/on-boarding-video/on-boarding-video.use-cases';
import { ON_BOARDING_VIDEO_USE_CASES } from '@app/domain/use-cases/on-boarding-video/on-boarding-video.use-cases.contract';

export const onBoardingVideoUseCasesProvider: Provider = {
  provide: ON_BOARDING_VIDEO_USE_CASES,
  useClass: OnBoardingVideoUseCasesImpl
};
